import { css } from "@emotion/css";
import { StepCard } from "@octopusdeploy/design-system-components";
import { KubernetesIcon, RocketIcon } from "@octopusdeploy/design-system-icons";
import { fontSize, fontWeight, letterSpacing, lineHeight, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import { nameForDocument, useAnalyticExternalLinkDispatch } from "~/analytics/Analytics";
export const ProjectsGettingStartedGuides = () => {
    const dispatchLink = useAnalyticExternalLinkDispatch();
    return (<div>
            <div className={bottomSectionStyles.subtitleStyles}>Getting Started Guides</div>
            <div className={bottomSectionStyles.stepCardsContainer}>
                <StepCard heading="First Kubernetes Deployment" description="Deploy sample YAML files to your Kubernetes cluster." logo={<KubernetesIcon size={24} color={themeTokens.color.icon.info}/>} primaryAction={{
            label: "Tutorial",
            href: "https://oc.to/FirstKubernetesGuide",
            onClick: () => dispatchLink("First Kubernetes Deployment", "https://oc.to/FirstKubernetesGuide", nameForDocument()),
            external: true,
        }}/>
                <StepCard heading="First Deployment" description="Deploy a sample hello world package to one of your servers." logo={<RocketIcon size={24} color={themeTokens.color.icon.info}/>} primaryAction={{
            label: "Tutorial",
            href: "https://oc.to/FirstDeploymentGuide",
            onClick: () => dispatchLink("First Deployment", "https://oc.to/FirstDeploymentGuide", nameForDocument()),
            external: true,
        }}/>
            </div>
        </div>);
};
// We set the minimum step card width to achieve the following:
//   - 2 columns when the container is 531px wide or wider
//   - 1 column when the container is less than 531px wide
const smallContainerMaxWidth = 530;
const sidePadding = 32;
const gap = 24;
const stepCardMinWidth = `${(smallContainerMaxWidth - 2 * sidePadding - gap) / 2}px`;
const bottomSectionStyles = {
    subtitleStyles: css({
        marginBottom: space[24],
        color: themeTokens.color.text.secondary,
        fontSize: fontSize.base,
        fontWeight: fontWeight["700"],
        lineHeight: lineHeight.small,
        letterSpacing: letterSpacing.wider,
    }),
    stepCardsContainer: css({
        display: "grid",
        gridTemplateColumns: `repeat(2, minmax(${stepCardMinWidth}, 1fr))`,
        gap: space[24],
        [`@container Level1EmptyStateLayout (width < ${smallContainerMaxWidth + 1}px)`]: {
            gridTemplateColumns: "1fr",
        },
    }),
};
